import React from "react"

export const FLAG_ROUND_ICON_SIZE_PX = 18

export const generateRoundFlagUrl = (countryIsoCode: string): string =>
  `https://pay.radom.com/flags/${countryIsoCode.toLowerCase()}.svg`

export const generateRoundFlagIcon = (flagUrl: string): React.ReactElement => {
  return <img
      style={{
        width: FLAG_ROUND_ICON_SIZE_PX,
        maxHeight: FLAG_ROUND_ICON_SIZE_PX,
        maxWidth: FLAG_ROUND_ICON_SIZE_PX,
        marginRight: 10
      }}
      src={flagUrl}
    />
}

export const generateRoundFlagIconFromCountryCode = (countryIsoCode: string, iconSize?: number): React.ReactElement => {
  const size = iconSize || FLAG_ROUND_ICON_SIZE_PX
  return <img
      style={{
        width: size,
        maxHeight: size,
        maxWidth: size,
        marginRight: 10
      }}
      src={generateRoundFlagUrl(countryIsoCode)}
    />
}